import { createFileRoute } from '@tanstack/react-router'

import { ActivitySearchRestaurantPage } from '../../../../components/pages/activity-search-restaurant-page.tsx'

export const Route = createFileRoute('/subscribe/restaurants-v2/identify')({
  component: ActivitySearchRestaurantPage,
})
